import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";





class ModalGuideline extends Component {
  
  render() {
    return (
      <Modal
        show={this.props.guidelineModal}
        size="xl"
        onHide={this.handleGuidelineModal}
        backdrop={'static'}        
      >
        
        <Modal.Body>
            <div style={{display:'flex',flexDirection:'column',justifyContent:'center'}}>
                <h3 style={{alignSelf:'center',margin:0,color:'#e96405'}}>Follow these guidelines to use the tool.</h3>
                <br></br><br></br>
                <ul>
                    <li style={{color:'#1d3e93'}}>File size must be less than 20 MB.</li><br></br>
                    <li style={{color:'#1d3e93'}}>Minimum 1 and Maximum 20 files are allowed to upload.</li><br></br>
                    <li style={{color:'#1d3e93'}}>Topological error must be checked and corrected before uploading the shape files.</li><br></br>
                    <li style={{color:'#1d3e93'}}>Only files with extensions .dbf, .cpg, .shp, .prj, .shx, .xml are allowed</li><br></br>
                    <li style={{color:'#1d3e93'}}>In WRDP, drainage file name must be 'filename_drainage' case sensitive.</li><br></br>
                    <li style={{color:'#1d3e93'}}>The attributes of shape files and data type of attributes must be same with the attributes present in the sample shape files.</li><br></br>
                    <li style={{color:'#1d3e93'}}>For LRDP, upload the Union Shape file (.shp) and corresponding files (.dbf, .cpg, .prj, .shx, .xml).</li><br></br>
                    <li style={{color:'#1d3e93'}}>For WRDP, upload the Union as well as Drainage Shape file and all the corresponding files of Union and Drainage shape files.</li><br></br>
                    
    
                </ul>
            </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.handleGuidelineModal}>Close</Button>
        </Modal.Footer>
       
      </Modal>
    );
  }
}

export default ModalGuideline;
